const COLOR_MAP = {
  rojo: "#d13a30",
  azul: "#467ab7",
  marino: "#2b4aae",
  blanco: "#ffffff",
  cian: "#d95095",
  amarillo: "#f7d717",
  naranja: "#f9882f",
  negro: "#000000",
  purpura: "#7066b5",
  rosa: "#ef6477",
  muerdago: "#3f7a5d",
  verde: "#59b969",
};

export const MARCO_DUO_COLORS = [
  "rojo",
  "azul",
  "marino",
  "blanco",
  "cian",
  "amarillo",
  "naranja",
  "negro",
  "purpura",
  "rosa",
  "muerdago",
  "verde",
].map((color) => ({
  id: color,
  name: color.charAt(0).toUpperCase() + color.slice(1),
  swatch: COLOR_MAP[color],
  frameSrc: `/images/frames-marco/marco-duo/marco-duo-${color}.png`,
}));

export const MARCO_DUO_CONFIG = {
  id: "marco-duo",
  name: "Marco Duo",
  canvas: {
    w: 1000,
    h: 600,
  },
  photoBoxes: [
    {
      id: "left",
      label: "Foto izquierda",
      x: 115,
      y: 120,
      w: 350,
      h: 350,
    },
    {
      id: "right",
      label: "Foto derecha",
      x: 535,
      y: 123,
      w: 350,
      h: 350,
    },
  ],
  imageBoxes: [
    {
      id: "left",
      label: "Foto izquierda",
      x: 120,
      y: 126,
      w: 345,
      h: 345,
    },
    {
      id: "right",
      label: "Foto derecha",
      x: 540,
      y: 126,
      w: 345,
      h: 345,
    },
  ],
};



